// Original: https://codepen.io/gorgonfreeman/pen/NWOEPrJ?editors=0110
const app = document.getElementById('app');

window.dialog;

class Dialog {
  constructor(message, id, options = { 'OK': undefined }, closeCallback) {

    if (window.dialog) {
      window.dialog.close();
    }

    this.message = message;
    this.id = id;
    this.closeCallback = closeCallback;
    this.el = this.spawn(options);
    this.closeButtons = this.el.querySelectorAll('.dialog_close');
    Array.from(this.closeButtons).forEach(button => {
      button.addEventListener('click', () => this.close());
    });

    // Use site utilities to freeze scroll and show an overlay - this code is not self-contained
    // window.themeUtils.freezeSite(app);
    // window.overlayFunctions.overlayToggle(true);
    // window.overlayFunctions.overlayAttachClick(() => this.close(), { once: true });
    // end

    window.dialog = this;
  }
  
  spawn(options) {
    const html = `<div role="dialog" aria-modal="true" aria-label="${ (this.message.replace(/<[^>]*>/g, '') || 'Dialog').trim().substring(0, 100) }" class="dialog" id="${ this.id }">
      <div class="dialog_inner">
        <button class="dialog_close" aria-label="Close">${ window.theme.icons.icon_cross('15px') }</button>
        <div class="dialog_body">
          <div class="dialog_message">
            ${ this.message }
          </div>
          <div class="dialog_buttons">
            ${ options ? Object.entries(options).map(([k,v]) => {
              return `<button id="dialogOption${ k.replaceAll(' ', '_').replaceAll(',', '').replaceAll('&', '') }" class="dialog_button _${ k.replaceAll(' ', '_').replaceAll(',', '').replaceAll('&', '') }">${ k }</button>`;
             }).join('') : '' }
          </div>
        </div>
      </div>
    </div>`;
    
    const bodyEl = document.querySelector('body');
    document.querySelector('body').insertAdjacentHTML('beforeend', html);
    // Because we're using beforeend, it's the last child
    const spawnedEl = bodyEl.lastChild;
    quietLog(spawnedEl);
    
    if (options) {
      Object.entries(options).forEach(([k, v]) => {
        const buttonID = `dialogOption${ k.replaceAll(' ', '_').replaceAll(',', '').replaceAll('&', '') }`;
        const button = spawnedEl.querySelector(`#${ buttonID }`);
        quietLog(button);
        button.addEventListener('click', () => {
          // If no callback supplied, close the modal without doing anything
          if (v) { 
            v(); 
          }
          this.close();
        });
      });
    }
    
    return spawnedEl;
  }
  
  close() {
    if (this.closeCallback) {
      this.closeCallback();
    }

    const animationDuration = getComputedStyle(this.el).getPropertyValue('--animation_duration');
    this.el.classList.add('_transition_out');
    
    setTimeout(() => {
      this.el.remove();

      // Use site utilities to freeze scroll and show an overlay - this code is not self-contained
      // window.overlayFunctions.overlayToggle(false);
      // window.themeUtils.thawSite(app);
      // end

    }, animationDuration);
  }
}

// const hi = new Dialog('Hi! How the hell are ya?');

// After any function is called, the dialog closes
// options = {
//   'Cancel': () => console.log('cancelCallback'),
//   'No': () => console.log('noCallback'),
//   'Yes': () => console.log('yesCallback'),
//   'Just close it': undefined,
// };

// const yo = new Dialog('Choose one of these:', options, () => console.log('closeCallback'));
// const yo2 = new Dialog('Choose one of these:', options);
// const yo3 = new Dialog('Choose one of these:', options);
// const yo4 = new Dialog('Choose one of these:', options);

const spawnDialog = (...args) => {
  const dialog = new Dialog(...args);
  return dialog;
};

window.spawnDialog = spawnDialog;

module.exports = {
  spawnDialog,
};

// window.spawnDialog('Hey, wtf?', { 'Yes': undefined, 'No': undefined });